import { Col, Form, Row, Select } from 'antd'
import withKeyValue from '../../../../elements/HOC/WithKeyValue'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { sessionItem } from '../../../../modules/Utils'
import React from 'react'
import { compose } from 'recompose'

const DangerousGoodsSelect = compose(
  withSelectFetch({
    dropdown: 'quotes',
    name: 'dangerousGoods',
  }),
  withSpinning,
  withSort,
)(CustomSelect)

function DangerousGoodsItem(props) {
  const { item, quote, viewOnly, resetFields, getFieldValue, getFieldDecorator, attrPrefix } = props
  const [{ Select: SubClassSelect }, setSubClassSelect] = React.useState({ Select })

  function onChange(c) {
    resetFields([attrPrefix + `dangerousGoods.${item}.subclass`])
    if (!isEmpty(c)) {
      const currentClass = sessionItem(`quotes_dangerousGoods_dropdown`, c, 'class')
      if (currentClass) {
        const CS = compose(withData({ data: currentClass.subclass }), withKeyValue())(CustomSelect)
        setSubClassSelect({
          Select: CS,
        })
      }
    }
  }

  React.useEffect(() => {
    onChange(getFieldValue(attrPrefix + `dangerousGoods.${item}.class`))
  }, [item])

  return (
    <Row>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Class'}>
          {getFieldDecorator(attrPrefix + `dangerousGoods.${item}.class`, {
            initialValue: get(quote, attrPrefix + `dangerousGoods.${item}.class`),
            // rules: rules.select,
          })(
            <DangerousGoodsSelect
              disabled={viewOnly}
              onChange={onChange}
              keyAtr={'class'}
              valueAtr={'class'}
            />,
          )}
        </Form.Item>
      </Col>
      {getFieldValue(attrPrefix + `dangerousGoods.${item}.class`) && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Sub Class'}>
            {getFieldDecorator(attrPrefix + `dangerousGoods.${item}.subclass`, {
              initialValue: get(quote, attrPrefix + `dangerousGoods.${item}.subclass`),
              rules: rules.select,
            })(<SubClassSelect keyAttr={'class'} disabled={viewOnly} />)}
          </Form.Item>
        </Col>
      )}
    </Row>
  )
}

DangerousGoodsItem.propTypes = {}
DangerousGoodsItem.defaultProps = {}

export default DangerousGoodsItem
